import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, capitalize, capitalizeWord } from './format'

export function fetchChantiers() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_CHANTIERS_START", payload: "" })

            console.log("fetch Chantier START")
            const res = await axios.get('/chantiers/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_CHANTIERS_ERROR", dispatch ) ) {               
                // let list = capitalize(orderByAsc(res.data, "chantier_name"), "chantier_name")
                dispatch({
                    type: "GET_CHANTIERS",
                    payload: formatList(res.data, "boxAssoId")
                })
                dispatch({ type: "FETCH_CHANTIERS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get chantiers list ", err);
            dispatch({ type: "FETCH_CHANTIERS_ERROR", payload: err })
        }
    }
}

export function updateChantier(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_CHANTIER_START", payload: "" })

            // console.log("update Chantier START")
            // const res = await axios.post("/chantiers/update", {data})
            // console.log({res});
            
            // if (checkErrorData(res, "UPDATE_CHANTIER_ERROR", dispatch ) ) {               
            //     data.chantier_name = capitalizeWord(data.chantier_name)
			// 	dispatch({
            //         type: "UPDATE_CHANTIER",
            //         payload: data
            //     })
			// 	dispatch({ type: "UPDATE_CHANTIER_FULFILLED", payload: "" })
			// }
        } catch(err) {
            console.log("[ERROR] update chantier ", err);
            dispatch({
                type: "UPDATE_CHANTIER_ERROR",
                payload: err
                
            })
        }
    }
}
export function addSpendingToChantier(list, boxAssoId) { // {list, boxAssoId}
    return async function(dispatch){
        try{
            dispatch({ type: "ADD_SPENDING_TO_CHANTIER_START", payload: "" })

            console.log("update Chantier START")
            const res = await axios.post("/chantiers/spending/add", {data: {list, boxAssoId} })
            console.log({res});
            
            if (checkErrorData(res, "ADD_SPENDING_TO_CHANTIER_ERROR", dispatch ) ) {               
				dispatch({
                    type: "ADD_SPENDING_TO_CHANTIER",
                    payload: {list, boxAssoId}
                })
				dispatch({ type: "ADD_SPENDING_TO_CHANTIER_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update chantier ", err);
            dispatch({
                type: "ADD_SPENDING_TO_CHANTIER_ERROR",
                payload: err
                
            })
        }
    }
}
export function getChantierPartList(spending_id) { 
    return async function(dispatch){
        // try{
        //     dispatch({ type: "GET_CHANTIER_PART_START", payload: "" })

        //     console.log("update Chantier START")
        //     const res = await axios.post("/chantiers/spending/part/list", {data: spending_id })
        //     console.log({res});
            
        //     if (checkErrorData(res, "GET_CHANTIER_PART_ERROR", dispatch ) ) {               
		// 		dispatch({
        //             type: "GET_CHANTIER_PART",
        //             payload: {list, boxAssoId}
        //         })
		// 		dispatch({ type: "GET_CHANTIER_PART_FULFILLED", payload: "" })
		// 	}
        // } catch(err) {
        //     console.log("[ERROR] update chantier ", err);
        //     dispatch({
        //         type: "GET_CHANTIER_PART_ERROR",
        //         payload: err
        //     })
        // }
    }
}
